import { useEffect } from "react";
import { getStructureMetadata } from "@repo/structure";
import { useEditorWebsocket } from "@hooks";
import { useEstimateEditorStore } from "@tools";

export const useHistoryManagerKeybinds = (structure) => {
  
  const socket = useEditorWebsocket();
  const editorStore = useEstimateEditorStore();
  
  const handleStructureActionHistory = (e) => {
    if(
      !editorStore.useHistoryManager
      || !(e.ctrlKey || e.metaKey)
      || e.target.tagName === "TEXTAREA" || e.target.tagName === "INPUT"
      || (e.target.className.includes("ql-editor") && !e.target.closest(".enable-undo"))
    )
      return;
    
    const isZKey = e.key.toUpperCase() === "Z";
    const isYKey = e.key.toUpperCase() === "Y";
    let patches = [];
    
    if(isYKey || (isZKey && e.shiftKey)) {
      e.preventDefault();
      if(!structure.historyManager?.redoLevels)
        return;
      patches = structure.historyManager?.history[structure.historyManager?.undoIdx].patches;
      structure.historyManager?.redo();
      // socket?.requestStructurePatch(patches, getStructureMetadata(structure));
    }
    else if(isZKey) {
      e.preventDefault();
      if(!structure.historyManager?.undoLevels)
        return;
      patches = structure.historyManager?.history[structure.historyManager?.undoIdx - 1].inversePatches.slice().reverse();
      structure.historyManager?.undo();
      // socket?.requestStructurePatch(patches, getStructureMetadata(structure));
    }
    
    if(patches.length > 0) {
      patches.forEach(p => {
        if(p.op === "comment")
          socket?.requestCommentMove(p.path, p.value);
        if(p.op === "commentName")
          socket?.requestCommentPathElementRename(p.path, p.value);
      });
      socket?.requestStructurePatch(patches.filter(p => p.op !== "comment" && p.op !== "commentName"), getStructureMetadata(structure));
    }
  }
  
  useEffect(() => {
    if(editorStore.useHistoryManager) {
      window.document.addEventListener("keydown", handleStructureActionHistory);
    }
    return () => {
      window.document.removeEventListener("keydown", handleStructureActionHistory);
    }
  }, [structure]);
}